import { getApiText } from '../../../shared/i18n/locale';

/**
 * Area / governorate API rows: bilingual field names differ by endpoint (`a_title`, `name_ar`, `arabic_title`).
 */
export function getAreaBilingualLabel(obj: Record<string, unknown> | null | undefined): string {
  if (obj == null || typeof obj !== 'object') {
    return '';
  }
  return (
    getApiText(obj, 'title', 'a_title') ||
    getApiText(obj, 'title', 'arabic_title') ||
    getApiText(obj, 'name', 'name_ar') ||
    getApiText(obj, 'name', 'arabic_title') ||
    (typeof obj.name === 'string' ? obj.name : '') ||
    (typeof obj.title === 'string' ? obj.title : '') ||
    ''
  );
}
